import { media } from 'src/components/base';
import styled, { css } from 'styled-components';

type AppProps = {
  layout?: string;
};
export const App = styled.div<AppProps>`
  ${props =>
    props.layout === 'raw-mobile' &&
    css`
      .header,
      .header--fixed-margin,
      .pj-footer {
        display: none;
      }
    `};
`;

export const Main = styled.section`
  min-height: calc(100vh - 390px);

  ${media.largeUp`
    display: flex;
    flex-direction: row;

    @supports (display: grid) {
      display: grid;
      grid-template-columns: auto 1fr;
    }
  `}
`;

export const Content = styled.div`
  width: 100%;

  ${media.mediumUp`
    order: 99;
  `};

  ${media.mediumDown`
    max-width: 100vw;
  `};
`;
